import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({baseURL: API, withCredentials: true});

export const apiGet = (path, params) => client.get(path, {params}).then(r => r.data);
export const apiPost = (path, data) => client.post(path, data).then(r => r.data);
export const apiPut = (path, data) => client.put(path, data).then(r => r.data);
export const apiDelete = (path) => client.delete(path).then(r => r.data);

export const apiUpload = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await client.post("/upload", form, {headers: {"Content-Type": "multipart/form-data"}});
  return res.data;
};

export default client;
